import { CONDUCTOR_WIDGET_WIDTH } from './dockState';

const SETLIST_DRAWER_SELECTOR = '[data-sl-drawer-overlay] > [role="dialog"]';
export const ORB_PANEL_SELECTOR = `.slide-pane_from_right, .slide-pane_from_left, .new-event-popup-content, .v3-edit-drawer-panel, ${SETLIST_DRAWER_SELECTOR}`;
const PANEL_GAP = 12;

export function getOpenOrbPanels(viewportWidth) {
  return Array.from(document.querySelectorAll(ORB_PANEL_SELECTOR)).flatMap((element) => {
    if (element.closest('.venue-conductor-orb-popup-content')) return [];
    if (element.closest('[hidden], [aria-hidden="true"], [inert]')) return [];
    const style = window.getComputedStyle(element);
    if (style.display === 'none' || style.visibility === 'hidden') return [];
    const sliding = element.classList.contains('slide-pane');
    if (sliding && !element.classList.contains('ReactModal__Content--after-open')) return [];
    if (element.classList.contains('ReactModal__Content--before-close')) return [];
    const rectangle = element.getBoundingClientRect();
    if (rectangle.width <= 0 || rectangle.height <= 0) return [];
    const setlistDrawer = element.matches(SETLIST_DRAWER_SELECTOR);
    const side = element.classList.contains('slide-pane_from_left')
      || (setlistDrawer && rectangle.left + rectangle.width / 2 < viewportWidth / 2) ? 'left' : 'right';
    const edge = sliding || setlistDrawer
      ? (side === 'left' ? rectangle.width : viewportWidth - rectangle.width)
      : (side === 'left' ? rectangle.right : rectangle.left);
    return [{ element, side, edge: Math.round(edge) }];
  });
}

export function positionBesideOrbPanels(preferred, panels, viewportWidth) {
  const left = Math.max(16, ...panels.filter((panel) => panel.side === 'left').map((panel) => panel.edge + PANEL_GAP));
  const right = Math.min(viewportWidth - CONDUCTOR_WIDGET_WIDTH - 16,
    ...panels.filter((panel) => panel.side === 'right').map((panel) => panel.edge - CONDUCTOR_WIDGET_WIDTH - PANEL_GAP));
  if (left > right) return preferred;
  return { x: Math.min(Math.max(preferred.x, left), right), y: preferred.y };
}
